<!-- eslint-disable -->
<template lang="pug">
    .multiplayer-game-menu__selectors
        cs-multiselect.selector.difficulty-selecor(
            :multiple="false",
            :show-labels="false",
            label="value",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedDifficulty",
            :options="difficulties",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_difficult') }}:
                |
        cs-multiselect.selector.actions-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedAmountOfActions",
            :options="amountsOfActions",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_actions') }}:
                |
        cs-multiselect.selector.players-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="playersAmount",
            :options="players",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_players') }}:
                |
        cs-spin-input.selector.speed-input(
            v-if="slug === 'AnzanWithTime'"
            type="text",
            :value="`${selectedSpeed}с`",
            :max="`${seconds[seconds.length - 1]}с`",
            :min="`${seconds[0]}с`",
            @increase="increaseSpeed",
            @decrease="decreaseSpeed",
            :disabled="gameState === 'started'"
        )
</template>

<script>
    /*eslint-disable*/
    import MultiplayerOptionsMixin from "../../../utils/multiplayer/optionsMixin";
    import AddSubConfig from "../../trainer/configs/AddSubConfig";

    const PLAYING_STATE = 'started';
    const COMMON_PARAMETERS_CHANGED_EVENT = 'commonParametersHasChanged';

    export default {
        mounted () {
            this.selectedDifficulty = this.difficulties.find(difficulty => this.commonParams.difficult === difficulty.value);
            this.selectedAmountOfActions = this.commonParams.amountOfActions;
            if (this.slug === 'AnzanWithTime') {
                this.selectedSpeed = this.commonParams.speed;
                this.currentSpeedIndex = this.seconds.indexOf(this.selectedSpeed);
            }
        },
        mixins: [MultiplayerOptionsMixin],
        watch: {
            selectedDifficulty: {
                handler (value, oldValue) {
                    if (oldValue !== null) {
                        this.commonParams.difficult = this.difficulties.find(difficult => difficult.value === value.value).value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'difficult', value: this.commonParams.difficult});
                    }
                }
            },
            selectedAmountOfActions: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.amountsOfActions = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'amountOfActions', value});
                    }
                }
            },
            selectedSpeed: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.speed = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'speed', value});
                    }
                }
            },
        },
        data () {
            return {
                selectedDifficulty: null,
                selectedAmountOfActions: 0,
                difficulties: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                        $isDisabled: false,
                        value: 1,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                        $isDisabled: false,
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false,
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false,
                        value: 4,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false,
                        value: 5,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                        name: 'Шестизначные цифры',
                        $isDisabled: false,
                        value: 6,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                        name: 'Семизначные цифры',
                        $isDisabled: false,
                        value: 7,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                        name: 'Восьмизначные цифры',
                        $isDisabled: false,
                        value: 8,
                    }
                ],
                selectedMultilineOptions: '',
                seconds: AddSubConfig.seconds,
                currentSpeedIndex: 0,
                selectedSpeed: 0,
            }
        },
        methods: {
            increaseSpeed () {
                this.currentSpeedIndex += 1;
                this.selectedSpeed = this.seconds[this.currentSpeedIndex];
            },
            decreaseSpeed () {
                this.currentSpeedIndex -= 1;
                this.selectedSpeed = this.seconds[this.currentSpeedIndex];
            },
        },
        computed: {
            amountsOfActions () {
                let amount = this.slug === 'AnzanWithTime' ? 101 : 16;
                return [...Array(amount).keys()].slice(2);
            }
        }
    }
</script>

<style scoped lang="scss">
    .multiplayer-game-menu__selectors {
        display: flex;
        width: 80%;
        margin: 20px;
    }
    .selector {
        margin: 0 10px;
        max-height: 44px;
        &:first-child {
            margin-left: 0;
        }
        @media screen and (max-width: 1439px) {
            max-width: 220px;
        }
    }
    .formula-selector {
        width: 150% !important;
    }
</style>
